<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import type { LabelProps } from 'reka-ui'
import { Label } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'

/**
 * shadcn-vue `Label`, in BG §19.3's system-label voice (the `ZhSystemLabel` recipe): uppercase mono at
 * the system tracking, 12px. Uppercased in CSS, not in the copy, so a screen reader reads words. Every
 * input has one, even where it is visually hidden (BG §22.3).
 */
const props = defineProps<LabelProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <Label
    data-slot="label"
    v-bind="delegatedProps"
    :class="
      cn(
        'flex items-center gap-2 font-mono text-xs leading-none font-medium uppercase tracking-[var(--tracking-system)] select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>
